import SkeletonWrapper from './SkeletonWrapper';

export default SkeletonWrapper;
